import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@/core/services/toast.service';
import { IntegrationCardData } from '../integration-card/integration-card.types';
import { IntegrationUtils } from '@/core/utils/integration-utils';
import { firstValueFrom } from 'rxjs';

export class IntegrationHelper {
    /**
     * Gets the name and search text for a given integration service. This is used for filtering.
     * @param translate TranslateService instance used for translation.
     * @param serviceId The serviceId of the integration service.
     * @returns The name and the search text for the integration service.
     */
    public static async getCardTranslations(
        translate: TranslateService,
        serviceId: string,
    ): Promise<{ name: string; searchText: string }> {
        try {
            const prefix = IntegrationUtils.getI18nPrefixString(serviceId);
            const nameKey = `${prefix}.name`;
            const descKey = `${prefix}.card_description`;
            const translations = await firstValueFrom(translate.get([nameKey, descKey]));
            const name = translations[nameKey];
            const desc = translations[descKey];
            return { name, searchText: `${name} ${desc}`.toLowerCase() };
        } catch (error) {
            console.error('Error getting card translations:', error);
        }
        return { name: '', searchText: '' };
    }

    public static showConnectSuccessToast(
        toastService: ToastService,
        translate: TranslateService,
        integrationName: string,
    ): void {
        toastService.successNoTranslate(
            translate.instant('standard_success'),
            translate.instant('set_int_connect_success_toast_details', {
                integrationName,
            }),
            8000,
        );
    }

    public static showConnectErrorToast(
        toastService: ToastService,
        translate: TranslateService,
        integrationName: string,
    ): void {
        toastService.errorNoTranslate(
            translate.instant('standard_error'),
            translate.instant('set_int_connect_error_toast_details', {
                integrationName,
            }),
            8000,
        );
    }

    public static getI18nPrefix(integration: IntegrationCardData): string {
        if (integration?.serviceId) {
            return IntegrationUtils.getI18nPrefixString(integration.serviceId);
        }
        console.error('IntegrationHelper.getI18nPrefix(): integration is undefined');
        return '';
    }
}
